// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { PFixField } from './PFixField';
export class PFixStringArrField extends PFixField {
    constructor(fieldId, buffer) {
        super(fieldId, buffer);
        this.Value = [''];
    }
    ReadValue(buffer) {
        const length = buffer.ReadInt32();
        const list = [];
        for (let i = 0; i < length; i++) {
            list.push(buffer.ReadString());
        }
        this.Value = list;
    }
    Write(buffer) {
        buffer.WriteShort(this.FieldId);
        const length = this.Value.length;
        buffer.WriteInt32(length);
        for (let i = 0; i < length; i++) {
            buffer.WriteString(this.Value[i]);
        }
    }
}
